import {
  AccountDetail,
  AccountDetailSchema,
  ApiRoute,
  ReferralStats,
  ReferralStatsSchema,
  getApiRoute
} from "@humanex/interfaces";

import { ApiClientConfig, BaseApiClient } from "./base-client";

export class ReferralApiClient extends BaseApiClient {
  constructor(config: ApiClientConfig) {
    super({
      ...config,
      baseEndpoint: getApiRoute(ApiRoute.REFERRAL),
      requireAuth: true
    });
  }

  async verifyCode(code: string): Promise<AccountDetail> {
    return await this.get(code, AccountDetailSchema, {
      requireAuth: false
    });
  }

  async getStats(orgId?: string): Promise<ReferralStats> {
    return await this.get(orgId ? `org/${orgId}/stats` : "me/stats", ReferralStatsSchema, {
      requireAuth: true
    });
  }
}
